// Webpack Imports
import $ from "jquery";

$.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

$.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

!function(e){"function"==typeof define&&define.amd?define(e):e()}(function(){var e,t=["scroll","wheel","touchstart","touchmove","touchenter","touchend","touchleave","mouseout","mouseleave","mouseup","mousedown","mousemove","mouseenter","mousewheel","mouseover"];if(function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}()){var n=EventTarget.prototype.addEventListener;e=n,EventTarget.prototype.addEventListener=function(n,o,r){var i,s="object"==typeof r&&null!==r,u=s?r.capture:r;(r=s?function(e){var t=Object.getOwnPropertyDescriptor(e,"passive");return t&&!0!==t.writable&&void 0===t.set?Object.assign({},e):e}(r):{}).passive=void 0!==(i=r.passive)?i:-1!==t.indexOf(n)&&!0,r.capture=void 0!==u&&u,e.call(this,n,o,r)},EventTarget.prototype.addEventListener._original=e}});


import { Collapse, Dropdown, Modal  } from 'bootstrap';
import './jss/slick';


(function ($) {
  $(document).ready(function () {

    $('#langSwitcher').on('click', function () {
       $('#langList').fadeToggle();
    });

    $('#searchSwitcher').on('click', function () {
       $('#searchForm').fadeToggle();
    });


    $('a').each(function () {
      if (location.hostname === this.hostname || 'dev.geographicatrophy.uk' === location.hostname || 'www.dev.geographicatrophy.uk' === location.hostname || 'www.geographicatrophy.uk' === location.hostname || 'www.staging.geographicatrophy.uk' === location.hostname || 'staging.geographicatrophy.uk' === location.hostname || '52.31.209.245' === location.hostname || 'geographicatrophy.uk' === this.hostname || 'geographicatrophy.eu' === this.hostname || !this.hostname.length || 'pre-lesion.com' === this.hostname ||  'geographicatrophy.com.au' === this.hostname ||  'dryamd.eu' === this.hostname ||  'apellis.com' === this.hostname || 'apellismedicalhub.com' === this.hostname || 'dryamd.uk' === this.hostname) {
        $(this).addClass('local');
      } else {
        $(this).addClass('external');
      }
    });

    $('a.external').click(function (e) {

      e.preventDefault();
      //console.log("extern clicked");

      $('#externalLink').addClass('show');

      var target = $(this).attr('target');
      var uri = $(this).attr('href');

      //console.log("target, uri:", target, uri);

      $('#externalLink .externalLink-ok').unbind();
      $('#externalLink .externalLink-ok').click(function (e) {

        var link = document.createElement('a');
        link.href = uri;
        link.target = target;
        document.body.appendChild(link);
        link.click();

        $('#externalLink').removeClass('show');

        return true;

      });

      $('#externalLink .externalLink-close').unbind();
      $('#externalLink .externalLink-close').click(function (e) {

        $('#externalLink').removeClass('show');

        return true;

      });

    });

	  
	/**
	 * COOKIE BANNER
	 */
    const cookieBanner = $('#cookieBanner');

    if (cookieBanner.length) {

      let cookieBannerClose = $('.cookieBanner-close');
      let cookieBannerNo = $('.cookieBanner-no');

      cookieBannerClose.on('click', function (e) {
        e.preventDefault();
        setCookie('cookieBanner', 'active', 365);
        cookieBanner.fadeOut();
      });

      cookieBannerNo.on('click', function (e) {
        e.preventDefault();
        setCookie('cookieBanner', 'no', 365);
        cookieBanner.fadeOut();
        document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
        window[disableStr] = true;
      });
	}
	  
	  
    
    const openPoll = $('#openPoll');
  
    if (openPoll.length) {
      const pollBanner = $('#pollBanner');
      let pollClose = $('.pollBanner-close');

      pollClose.on('click', function (e) {
        e.preventDefault();
        pollBanner.removeClass('show');
      });

      $('body').on('click', '.pollBanner-finish', function (e) {
        e.preventDefault();
        pollBanner.removeClass('show');
      });

      openPoll.on('click', function (e) {
        e.preventDefault();
        pollBanner.addClass('show');
      });

    }
	  
  });


function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}




let videoPlayers = $('.video-player');

if (videoPlayers.length) {
    videoPlayers.each(function () {
      const videoBlock = $(this).find('.wp-block-video');
      const videoButtons = $(this).find('.specialButton__button');

      //only show the first video
        videoBlock.hide();
        videoBlock.eq(0).show();
      

      videoButtons.each(function (index) { 
        $(this).on('click', function (e) {
          e.preventDefault();
          //videoPlayers.hide();

          if($(this).hasClass('active') && !$(this).hasClass('paused')){
            // this video is playing so pause it
            videoBlock.eq(index).find('video').trigger('pause');
            $(this).addClass('paused');
          }else if($(this).hasClass('paused')){
            // this video is paused so play it
            videoBlock.eq(index).find('video').trigger('play');
            $(this).removeClass('paused');
            console.log('restart?')
          }else{
            //another video has been triggered
            videoBlock.each(function () {
              $(this).hide();
              $(this).find('video').trigger('pause');
            });
            videoButtons.each(function (index) { 
              $(this).removeClass('active');
              $(this).removeClass('paused');
            });

            $(this).addClass('active');
            videoBlock.eq(index).show();
            videoBlock.eq(index).find('video').trigger('play');
          }
          
        });
      });

    });
}






  if ($('.init_slider').length) {
		$('.init_slider').slick({
			dots: true,
			speed: 500,
			infinite: false,
			prevArrow: $('.prev'),
			nextArrow: $('.next'),
			customPaging : function(slider, i) {
				return '<a href="#"><div class="slick-dot-custom"></div></a>';
			},
		});
	}

	if ($('.headerSlick-init').length) {
		$('.headerSlick-init').slick({
			dots: true,
			speed: 700,
			infinite: true,
			autoplay: true,
      autoplaySpeed: 6000,
			prevArrow: $('.prev'),
			nextArrow: $('.next'),
      customPaging : function(slider, i) {
				return '<a href="#"><div class="slick-dot-custom"></div></a>';
			},
		});
	}


})($);